<!-- 组件说明 -->
<template>
  <a-modal
    title="选择标签"
    placement="right"
    :closable="false"
    :visible="showdrawer"
    @close="noShowDrawer"
  >
    <a-tree
      checkable
      :tree-data="treeData"
      :default-expanded-keys="['0-0-0', '0-0-1']"
      :default-selected-keys="['0-0-0', '0-0-1']"
      :default-checked-keys="['0-0-0', '0-0-1']"
      :replace-fields="replaceFields"
      @select="onSelect"
      @check="onCheck"
    />
  </a-modal>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>

<style scoped></style>
